/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Book_Sent_SpamInputs */

const en_guest_book_sent_spam = /** @type {(inputs: Guest_Book_Sent_SpamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can't see it? Check spam or the Promotions tab.`)
};

const pl_guest_book_sent_spam = /** @type {(inputs: Guest_Book_Sent_SpamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie widzisz maila? Zajrzyj do spamu albo zakładki Oferty.`)
};

/**
* | output |
* | --- |
* | "Can't see it? Check spam or the Promotions tab." |
*
* @param {Guest_Book_Sent_SpamInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const guest_book_sent_spam = /** @type {((inputs?: Guest_Book_Sent_SpamInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Book_Sent_SpamInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_guest_book_sent_spam(inputs)
	return en_guest_book_sent_spam(inputs)
});